module.exports = __webpack_public_path__ + "img/4.53e9ee74.svg";